import MainPanel from '../components/MainPanel/MainPanel';
import DefaultLayout from '../layout/Layout';

const Transfer = () => {
  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>Transfer</MainPanel>
    </DefaultLayout>
  );
};
export default Transfer;
